import { useContext } from 'react'
import { useQuery, QueryKey } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import ApiContext from '../../context/ApiContext'

export const getCompaniesQueryKey = (): QueryKey => ['companies', 'all']

export type Company = {
	id: string
	name: string
	createdAt: string
	managerUserUids: string[]
	disabledUserIds: string[]
	stripeCustomerId: string
	personalAccount: boolean
}

interface UseCompaniesResult {
	companies: Company[]
	isLoading: boolean
	error: Error | null
	refetch: () => void
}

const useCompanies = (enabled: boolean = true): UseCompaniesResult => {
	const apiContext = useContext(ApiContext)

	const {
		data: companies = [],
		isLoading,
		error,
		refetch,
	} = useQuery({
		queryKey: getCompaniesQueryKey(),
		queryFn: async (): Promise<Company[]> => {
			const auth = getAuth()
			const idToken = await auth.currentUser?.getIdToken(true)
			const response = await fetch(`${apiContext.apiUrl}/users/all-companies`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${idToken}`,
				},
			})

			if (!response.ok) {
				throw new Error(await response.text())
			}

			const companies = await response.json()
			return companies || []
		},
		enabled,
	})

	return { companies, isLoading, error, refetch }
}

export default useCompanies
